
import { Component } from '@angular/core';

@Component({
	selector: 'app-quote-coverage-card-skeleton',
	imports: [],
	templateUrl: './quote-coverage-card-skeleton.component.html',
	styleUrl: './quote-coverage-card-skeleton.component.scss',
})
export class QuoteCoverageCardSkeletonComponent {}
